// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.9995 1H3.99951V23H19.9995V11H17.9995V17H5.99951V3H14.9995V1ZM13.0034 19V21.0039H10.9995V19H13.0034Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0006 1.00195V5.58769L21.5011 4.08706L22.9154 5.50125L19.0006 9.41619L15.0838 5.49941L16.4981 4.0852L18.0006 5.58772V1.00195L20.0006 1.00195Z"}}]};

const InstallMobileFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'install-mobile-filled',
    ref,
    icon: element,
  },
));

InstallMobileFilledIcon.displayName = 'InstallMobileFilledIcon';

export default InstallMobileFilledIcon;
